import { RoleEnum, SpecialistType } from '@utils/util.types';

export const specialistTypeRoles = [
	{ role: SpecialistType.Individual, title: 'Individual Specialist' },
	{ role: SpecialistType.Company, title: 'Consulting Company' },
];

export const generalRegistrationRoles = [
	{
		role: RoleEnum.Farmer,
		title: 'farmerCard',
		description: 'farmerCardDescription',
	},
	{
		role: RoleEnum.Specialist,
		title: 'individualSpecialist',
		description: 'specialistCardDescription',
	},
	{
		role: RoleEnum.Company,
		title: 'individualCompany',
		description: 'specialistCardDescription',
	},
];
